// extracted by mini-css-extract-plugin
module.exports = {"goods-list-radio":"goods-list-radio-030bd769c72391ca9547c3ec36d8b900"};